import { useContext, useState } from "react";
import { FaGreaterThan } from "react-icons/fa";
import { Link } from "react-router-dom";
import axiosPrivate from "../../../hooks/axiosPrivate";
import LoaderContext from "../../../context/loader/LoaderContext";
import styles from "./dealer.module.css";
import { showErrorToast, showSuccessToast } from "../../../Toster";
import DealerTable from "./DealerTable";

const Dealer = ({ authPermission }) => {
  const { setIsLoading } = useContext(LoaderContext);
  const [isSync, setIsSync] = useState(false);
  // header
  const headers = [
    { name: "DEALER NAME", field: "name", sortable: true, classKey: "w250" },
    { name: "EMAIL", field: "email", sortable: true, classKey: "" },
    { name: "CONTACT NO.", field: "mobile", sortable: true, classKey: "" },
    { name: "ROLE", field: "roles", sortable: true, classKey: "" },

    { name: "ACTION", field: "action", classKey: "" },
  ];

  const syncDealerFromTally = async () => {
    setIsLoading(true); // Show loader
    setIsSync(true); // Show loader
    await axiosPrivate
      .post("tally/fetch/dealers/from/tally", null, { timeout: 3000000 })
      .then((response) => {
        showSuccessToast("Dealers synced successfully");
      })
      .catch((error) => {
        if (Array.isArray(error.response.data.errors)) {
          showErrorToast(error.response.data.errors[0]?.msg);
        } else {
          showErrorToast(error.response.data.errors?.msg);
        }
      })
      .finally(() => {
        setIsLoading(false); // Hide loader
        setIsSync(false);
      });
  };

  return (
    <>
      <div className="section-body">
        <div className="container-fluid d-flex justify-content-between">
          {/* hearder breadcrumb */}
          <div className="card-header">
            <strong className="top-left-heading">Dealers</strong>

            <ol className="headerroutes breadcrumb m-0 bg-none ">
              <li className="item color-gray">|</li>
              <li className="item">
                <Link to="/admin/dashboard" className="route-heading item mx-2">
                  Dashboard
                </Link>
              </li>
              <li className="item">
                <FaGreaterThan className="grater-than-route" />
              </li>
              <li className="route-heading item mx-2 mt-1">Dealers</li>
            </ol>
          </div>

          {isSync && (
            <div className={styles.overlayMessage}>
              Dealers syncing from Tally...
            </div>
          )}
          <button
            type="button"
            className={`btn btn-primary add_btn ${styles?.syncTallyButton}`}
            data-toggle="modal"
            data-target="#exampleModal"
            onClick={syncDealerFromTally}
          >
            Sync Tally
          </button>
        </div>
        <div className="section-body ">
          <div className="container-fluid">
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="dealer-list"
                role="tabpanel"
              >
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {<DealerTable headers={headers} />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dealer;
